import { UserMenu } from '@/components/ui'

export default function HeaderNavigation() {
  return (
    <div className="flex items-center gap-2">
      <UserMenu />
    </div>
  )
}